import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';

export const DividendDepositModal = ({
  hide,
  isShow,
}: {
  isShow: boolean;
  hide: () => void;
}): React.ReactElement => {
  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto text-sm text-bluegray-700">
          <div className="flex flex-row">
            <div className="flex-grow text-lg font-bold text-gray-800">
              入金データについて
            </div>
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="mt-2 leading-6">
            入金額やチャートは証券会社の入出金データを元に表示をしています。
          </div>
          <div className="mt-6 font-bold">表示可能な証券会社</div>
          <div className="mt-1 leading-6">
            【対応証券と取得可能な履歴の件数】
            <br />
            ・SBI証券：直近2年以内の全履歴
            <br />
            ・楽天証券：直近5年以内の全履歴
            <br />
            【未対応】
            <br />
            ・上記以外の証券会社
            <br />
            ・確定拠出年金口座
            <br />
            ・マネーツリーで連携した口座
            <br />
            また、配当金・分配金・利金の受け取りを証券口座以外に設定している場合は表示されません。
          </div>
          <div className="mt-6 font-bold">SBI証券の更新時間</div>
          <div className="mt-1 leading-6">
            SBI証券の入金情報は以下時間に更新されます。
            <br />
            ・15:00~22:00
          </div>
          <div className="mt-6 font-bold">表示される入金情報</div>
          <div className="mt-1 leading-6">
            ・国内株式、外国株式の配当金
            <br />
            ・投資信託の分配金
            <br />
            ・国内・外国ETF/ETNの分配金
            <br />
            ・国内・外国REITの分配金
            <br />
            ・国内・外国債券の利金
          </div>
          <div className="mt-6 leading-6">
            その他、ご不明な点がございましたら以下よりお問い合わせください。
          </div>
          <div className="text-blue-700">
            <a
              href="https://support.minkabu.jp/hc/ja/requests/new?ticket_form_id=360002511233"
              target="_blank"
              rel="noopener noreferrer">
              <div className="flex flex-row">
                <span>お問い合わせ</span>
              </div>
            </a>
          </div>

          <button className="mt-4 p-2 justify-center w-full" onClick={hide}>
            閉じる
          </button>
        </div>
      </Modal2>
    </>
  );
};
